<div id="login-page">
  <app-minimalist-entry>
    <a slot="link" class="selected" [routerLink]="['/register']">
      <span
        style="margin-left: 10px; color: #73809C; cursor: pointer; cursor: default;"
        i18n="register link option|The register label of the link that redirects to the register screen@@registerRedirectLinkLabel"
      >Signup</span>
    </a>
    <a slot="link" [routerLink]="['/login']">
      <span
        style="margin-left: 10px; text-decoration: underline;"
        i18n="login link option|The login label of the link that redirects to the login screen@@loginRedirectLinkLabel"
      >Login</span>
    </a>
    <div slot="content">
      <form class="form-login" [formGroup]="form">
        <div class="form-inner-group input-group double-row names">
          <div class="first-name double-group">
            <input
              formControlName="firstName"
              type="text"
              class="form-control"
              i18n-placeholder="first name placeholder|The placeholder that is visible at the first name input before a content is written to it@@firstNameAddressPlaceholder"
              placeholder="First Name"
              autocomplete="first-name"
              autofocus
              required
              [readonly]="this.loading"
            >
          </div>
          <div class="last-name double-group">
            <input
              formControlName="lastName"
              type="text"
              class="form-control"
              i18n-placeholder="last name placeholder|The placeholder that is visible at the last name input before a content is written to it@@lastNameAddressPlaceholder"
              placeholder="Last Name"
              autocomplete="last-name"
              autofocus
              required
              [readonly]="this.loading"
            >
          </div>
        </div>
        <div class="form-inner-group input-group email">
          <input
            formControlName="email"
            type="email"
            class="form-control"
            i18n-placeholder="email address placeholder|The placeholder that is visible at an email address input before a content is written to it@@emailAddressPlaceholder"
            placeholder="Email Address"
            autocomplete="email"
            spellcheck="false"
            required
            [readonly]="this.loading"
          >
        </div>
        <div class="form-inner-group input-group password">
          <input
            formControlName="password"
            type="password"
            class="form-control"
            i18n-placeholder="password placeholder|The placeholder that is visible at an password input before a content is written to it@@passwordPlaceholder"
            placeholder="Password"
            autocomplete="new-password"
            [readonly]="this.loading"
            spellcheck="false"
            required
          >
        </div>
        <div class="form-inner-group input-group confirm-password">
          <input
            formControlName="passwordConfirm"
            type="password"
            class="form-control"
            i18n-placeholder="confirm password placeholder|The placeholder that is visible at an password confirmation input before a content is written to it@@confirmPasswordPlaceholder"
            placeholder="Confirm password"
            autocomplete="new-password"
            [readonly]="this.loading"
            spellcheck="false"
            required
          >
        </div>
        <div class="form-inner-group input-group company">
          <input
            formControlName="company"
            type="text"
            class="form-control"
            i18n-placeholder="confirm company placeholder|The placeholder that is visible at an company input before a content is written to it@@companyPlaceholder"
            placeholder="Company"
            autocomplete="company"
            required
            [readonly]="this.loading"
          >
        </div>
        <div class="form-inner-group input-group double-row country telephone">
          <div class="country double-group">
            <select
              formControlName="country"
              type="text"
              class="form-control"
              i18n-placeholder="confirm country placeholder|The placeholder that is visible at an country input before a value is selected to it@@countryPlaceholder"
              placeholder="Country"
              autocomplete="country"
              required
              [disabled]="this.loading"
              [style.color]="country.value === '' ? '#777' : '#495057'"
            >
              <option
                disabled
                value=""
                selected
                i18n="confirm country placeholder|The placeholder that is visible at an country input before a value is selected to it@@countryPlaceholder"
              >Country</option>
              <option *ngFor="let country of countries; index as i" [value]="i">{{ country.name + ' ' + country.codeNumber }}</option>
            </select>
          </div>
          <div class="phone double-group">
            <input
              formControlName="telephone"
              type="text"
              class="form-control"
              i18n-placeholder="confirm telephone placeholder|The placeholder that is visible at an telephone input before a content is written to it@@telephonePlaceholder"
              placeholder="Phone Number"
              autocomplete="phone"
              required
              [readonly]="this.loading"
            />
          </div>
        </div>
        <div [ngClass]="{'form-inner-group': true, 'captcha-wrapper': true, 'visible': captchaVisibleAnimation}" *ngIf="!successfullySent">
          <re-captcha (resolved)="onCaptchaResolved($event)" siteKey="6LdbK30UAAAAAKNqX3sLt1fQhe8aUrPKy2vVCMHI"></re-captcha>
        </div>
        <div class="form-inner-group alert-wrapper" *ngIf="(attemptedSubmit && form.invalid && form.dirty) || errorMessage">
          <div *ngIf="form.invalid && form.dirty">
            <ul class="alert alert-danger">
              <li *ngIf="!token.invalid && token.value.length !== 0 && !email.invalid && !firstName.invalid && !lastName.invalid">The form is invalid</li>
              <li
                *ngIf="firstName.invalid && firstName.dirty"
                i18n="first name is required|Error message for when the first name is missing or invalid@@firstNameRequired"
              >First name is required</li>
              <li
                *ngIf="lastName.invalid && lastName.dirty"
                i18n="last name is required|Error message for when the last name is missing or invalid@@lastNameRequired"
              >Last name is required</li>
              <li
                *ngIf="email.invalid && email.dirty"
                i18n="email is required|Error message for when the email is missing or invalid@@emailRequired"
              >Email is required</li>
              <li
                *ngIf="password.invalid && password.dirty"
                i18n="password is required|Error message for when the password is missing or invalid@@passwordRequired"
              >Password is required</li>
              <li
                *ngIf="company.invalid && company.dirty"
                i18n="company is required|Error message for when the company is missing or invalid@@companyRequired"
              >Company is required</li>
              <li
                *ngIf="telephone.invalid && telephone.dirty"
                i18n="phone is required|Error message for when the phone is missing or invalid@@telephoneRequired"
              >Phone number is required</li>
              <li
                *ngIf="country.invalid && country.dirty"
                i18n="country is required|Error message for when the country is missing or invalid@@countryRequired"
              >Country is required</li>
              <li
                *ngIf="token.invalid || token.value.length === 0"
                i18n="token is required|Error message for when the token is missing or invalid@@tokenRequired"
              >Token is required</li>
            </ul>
          </div>
          <div *ngIf="errorMessage">
            <div class="alert alert-danger">{{ errorMessage }}</div>
          </div>
        </div>
        <div
          class="form-inner-group alert alert-success"
          *ngIf="successfullySent"
          i18n="successfull register message|The message that shows up once the user successfully creates his account and is about to be redirected to login@@successfullRegisterMessage"
        >You have created your account! You will be redirected to login shortly.</div>
        <div class="usage-terms">
          <span i18n="register page terms of service prefix|The text that precedes the terms of service link@@registerPageServiceTermsPrefix">By signing up, you accept our</span>
          <a
            i18n="terms of service link|The text in the link that redirects the user to the terms of service and privacy policy page@@privacyPolicyLinkLabel"
            target="_blank"
            href="assets/ReportsFeedContractEnglish.pdf"
          >Terms of Service and Privacy Policy.</a>
        </div>
        <div class="form-inner-group actions">
          <button type="button" class="btn btn-theme btn-block btn-with-left-icon" (click)="onRegisterClick()" [disabled]="successfullySent">
            <i *ngIf="!loading" class="fa fa-lock"></i>
            <i *ngIf="loading" class="fa fa-circle-o-notch fa-spin"></i>
            <span
              *ngIf="successfullySent"
              i18n="successfull register button label|The main submit button label for the account register form page once the user successfully creates his account@@successfullRegisterButtonLabel"
            >Done!</span>
            <span
              *ngIf="!successfullySent"
              i18n="register button label|The main submit button label for the account register form page@@registerButtonLabel"
            >Register</span>
          </button>
        </div>
      </form>
    </div>
  </app-minimalist-entry>
</div>
